<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>

    <!-- Data PPAK -->
    <CCardBody ref="mycardloader">
      <CRow>
        <div class="col-sm-12 col-xl-12">
            <h5>Filter</h5>
        </div>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for="" class="font-weight-bold">Tanggal Pelaksanaan</label>
            <input type="text" name="daterange" id class="form-control" placeholder="Pilih Tanggal" autocomplete="off"/>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>        
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>
            <template #kode_rpl="{item}">
              <td class="py-2">{{ item.kode_rpl ? item.kode_rpl : "-"}}</td>
            </template>
            <template #nama_rpl="{item}">
              <td class="py-2">{{ item.nama_rpl ? item.nama_rpl : "-"}}</td>
            </template>
             <template #nama_level="{item}">
              <td class="py-2">{{ item.nama_level ? item.nama_level : "-"}}</td>
            </template>
            <template #biaya="{item}">
              <td class="py-2">Rp {{formatPrice(item.biaya) ? formatPrice(item.biaya) : "-"}}</td>
            </template>
             <template #biaya_permata_uji="{item}">
              <td class="py-2">Rp {{formatPrice(item.biaya_permata_uji) ? formatPrice(item.biaya_permata_uji) : "-"}}</td>
            </template>
            <template #mata_uji="{item}">
              <td class="py-2 text-center font-weight-bold">{{item.mata_uji.length ? item.mata_uji.length : "-"}}</td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <router-link :to="'/sertifikasi/master-rpl-ppak/edit/'+item.id_sertifikasi_rpl">
                  <CButton v-c-tooltip="'Ubah'" color="info" class="btn-sm mx-1" square>
                    <font-awesome-icon icon="edit" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <!-- End Data PPAK -->
</template>
<script>
import RplPpakService from "../../../../services/sertifikasi/master-rpl-ppak.service";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "kode_rpl",
    label: "Kode",
    sorter: true,
    filter: false
  },
  {
    key: "nama_rpl",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "nama_level",
    label: "Level",
    sorter: true,
    filter: false
  },
  {
    key: "biaya",
    label: "Biaya Pendaftaran",
    sorter: true,
    filter: false
  },
  {
    key: "biaya_permata_uji",
    label: "Biaya Per Mata Uji",
    sorter: true,
    filter: false
  },
  {
    key: "mata_uji",
    label: "Jumlah Mata Uji",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "MasterRplPpak",
  data() {
    return {
      pageSize: "",
      search: "",
      fields,
      pagination: {
        totalPages: 0
      },
      currentPage: 0,
      details: [],
      no: 1,
      items: [],
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  watch: {
    search : function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
        // enter this block of code after 1 second
        // handle stuff, call search API etc.
        vm.getData("0", vm.pageSize, vm.search);

      }, 1000);
    },
  },
  mounted() {
    this.getData("0", this.pageSize, "default");
    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true,
        },
        function(start, end, label) {
          // comment console console.log(
            
        }
      );
    });
  },
  methods: {
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    cariData(){
      this.getData("0", this.pageSize, this.search);
    },
    getData(currentPage, pageSize, filter){
      let loader = this.$loading.show({
        container: false ? null :this.$refs.mycardloader,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
      RplPpakService.getRplPpak(currentPage, pageSize, filter)
      .then(response => {
        loader.hide();
        // comment console console.log(response.data.data.content);
        this.items = response.data.data.content;
        this.pagination.totalPages = response.data.data.totalPages;
        this.currentPage = response.data.data.pageable.pageNumber + 1;

      })
      .catch(error => {
        // comment console console.log(error);
      });

    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertError(message) {
      this.$swal.fire({
        title: "Peringatan!",
        text: message,
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item) {
      var vm = this;
      // comment console console.log(item)
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null :this.$refs.mycardloader,
              canCancel: true,
              onCancel: this.onCancel
            });
            RplPpakService.deleteRplPpak(item.id_sertifikasi_rpl)
            .then(response => {
              // comment console console.log(response);
              loader.hide();
              vm.alertSuccess();
              vm.getData("0", "10", "default");
            })
            .catch(error => {
              loader.hide();
              vm.alertError(error.response.data.message);
              // comment console console.log(error.response.data.message);
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    formatPrice(value){
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>